export enum AutoTilingState {
    Setup = "setup",
    InProgress = "in-progress",
    Complete = "complete",
    Failed = "failed",
}

export enum AutoTilingViewMode {
    Setup = "setup",
    Result = "result",
}
